import { FC } from "react";

import styles from "./Location.module.scss";
import { CareerBackInterfacesDTOVacancyVacancyPreviewDto } from "../../ApiContract/data-contracts";
import { classNames } from "../../lib/classNames";

interface LocationProps {
    city: CareerBackInterfacesDTOVacancyVacancyPreviewDto["city"];
    className?: string;
}

export const Location: FC<LocationProps> = ({ city, className }) => (
    <p
        className={classNames({
            cls: styles.location__city,
            additional: [className],
        })}
    >
        {city}
    </p>
);
